<template>
  <div>
    <div class="courseitem">
      <img
        src="~@/assets/images/mainindex/course-pic@2x.png"
        alt=""
        class="courseitem_img"
      />
      <div class="courseitem_title">啦啦之星教学-街舞啦啦操</div>
      <div class="courseitem_desc">
        <div class="courseitem_desc_person">217人学习</div>
        <div class="courseitem_desc_money">120.00</div>
        <img
          src="~@/assets/images/mainindex/icon-free-tag@2x.png"
          class="courseitem_desc_img"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CourseItem",
};
</script>
<style lang="scss" scoped>
.courseitem {
  position: relative;
  width: 290px;
  height: 242px;
  background: #ffffff;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  box-sizing: border-box;
  overflow: hidden;
  transition: all 0.3s;
  &:hover {
    box-shadow: 0px 4px 10px 0px #3b8de3;
    cursor: pointer;
  }
  .courseitem_img {
    width: 290px;
    height: 148px;
    object-fit: cover;
  }
  .courseitem_title {
    height: 32px;
    font-size: 18px;
    font-weight: 500;
    color: #000000;
    line-height: 32px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin: 5px 8px 17px 8px;
  }
  .courseitem_desc {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin: 0 8px;
    .courseitem_desc_person {
      height: 32px;
      font-size: 14px;
      font-weight: 400;
      color: #666666;
      line-height: 32px;
    }
    .courseitem_desc_money {
      height: 32px;
      font-weight: 400;
      font-size: 20px;
      color: #fa6400;
      line-height: 32px;
      position: relative;
      &::before {
        content: "￥";
        color: #fa6400;
        font-size: 16px;
        position: absolute;
        left: -11px;
        bottom: -1px;
      }
    }
    .courseitem_desc_img {
      width: 68px;
      height: 31px;
      position: absolute;
      right: 0;
      bottom: 0;
      display: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// CourseItem.vue?0f1c78a3